import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getToken, checkToken, urlLogin, getUuid, setUserActivityData, setUserContData, setPhishingData, setUserChapters, getAppVersion } from './constants';

interface Session {
    activeToken: string
    unAuthenticate: () => void
    isOnboarding: boolean
}

const Session: React.FC<Session> = ({activeToken,unAuthenticate,isOnboarding}) => {

    const navigate = useNavigate()
    const timeoutAmount = 300000
    //const timeoutAmount = 5000
    const uuidToken = getUuid()

    const localAppVersion = process.env.REACT_APP_VERSION
    const appVersion = getAppVersion()

    useEffect(() => {
        const verifyToken = async () => {
            if (activeToken && uuidToken) {                
                const tokenValid = await checkToken(activeToken, uuidToken);
                if (tokenValid.uuid === "false" || (localAppVersion !== appVersion) ) {
                    unAuthenticate();
                    navigate(urlLogin);
                    return;
                }
                return;
            }
            if(!isOnboarding)
            {
                navigate(urlLogin);
            }
        };
        verifyToken();
        const intervalId = setInterval(() => {
            verifyToken();
        }, timeoutAmount);

        return () => clearInterval(intervalId);
    }, [activeToken, uuidToken, navigate]);

    return <></>;
};

export default Session;